import React, { useEffect, useState, useRef } from 'react';
import lodash from 'lodash';
import config from "../../../config.json";
import apiRequest from '../../../utils/api.request';
import { vaccinationApiRequestBody } from "../../VaccinationDetails/VaccinationDetailsWrapper/Utils/vaccinationApiRequestBody";
import useTranslation from '../../../hooks/use-translation';
import moment from 'moment';
import UploadVaccineComponent from '../../VaccinationCertificate/UploadVaccineComponent';
import GetLastVaccinationDetails from '../../VaccinationCertificate/GetLastVaccinationDetails';

import './updateVaccineDetails.css';

const dateFormat = "DD-MM-YYYY";

const UpdateVaccineDetails = ({ question, hideQuestion = false, doseNo, vaccine_select_options, params, _onSubmitFinish, _afterYesClick, _handleNoClick, showUpperHr=false }) => {
  const { t, language } = useTranslation();
  const [date, _setDate] = useState("");
  const [vaccine, _setVaccine] = useState("");
  const [pageLoadError, setPageLoadError] = useState();
  const [showManualForm, _setShowManualForm] = useState(false);
  const [showUploadBox, _setShowUploadBox] = useState(false);
  const [disableOptions, _setDisableOptions] = useState(false);
  const [submitDetails, _setSubmitDetails] = useState(false);
  const [submitSuccess, _setSubmitSuccess] = useState(false);
  const [vccineDetailsInput, _setVccineDetailsInput] = useState(false);
  const [error, _setError] = useState({ name: "", date: "" });
  const [apiError, _setApiError] = useState("");

  const divRef1 = useRef(null);
  const divRef2 = useRef(null);

  const executeScroll = (divRef) => {
    if (divRef.current) {
      divRef.current.scrollIntoView()
    }
  }

  useEffect(() => executeScroll(divRef1));
  useEffect(() => executeScroll(divRef2));

  const _handleYesClick = () => {
    _setShowManualForm(true);
    _afterYesClick();
  }

  const _dateInput = (e) => {
    _setError({
      ...error,
      date: ""
    })
    _setDate(e.target.value);
  }

  const _vaccineInput = (e) => {
    if (e.target.value !== "") {
      _setError({
        ...error,
        name: ""
      })
      _setVaccine(e.target.value)
    }
  }

  const _handleManual = () => {
    _setVccineDetailsInput(true);
    _setShowUploadBox(false);
  }

  const _handleUpload = () => {
    _setVccineDetailsInput(false);
    _setShowUploadBox(true);
  }

  const _validate = () => {
    if (vaccine === "") {
      _setError({
        ...error,
        name: "Please select a vaccine"
      })
      return false;
    } else if (date === "" || new Date(date).getTime() > new Date().getTime() || new Date(date).getTime() < new Date("2020-03-01").getTime() || !(moment(moment(date).format(dateFormat),dateFormat,true).isValid())) {
      var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));
      
      if(isSafari)
      _setError({
        ...error,
        date: "Please enter a valid date in YYYY-MM-DD"
      })
      
      else
      _setError({
        ...error,
        date: "Please enter a valid date"
      })
      
      return false;
    }
    return true;
  }

  const _onReportManuallySubmit = async () => {
    if (!_validate()) return;
    const source_id = lodash.get(params, "source_id", "").toLowerCase();
    const auth_token = lodash.get(params, "auth_token", "");
    const source_user_id = lodash.get(params, "source_user_id", "");
    const source_relation = lodash.get(params, "source_relation", "");
    const source_user_relation_id = lodash.get(params, "source_user_relation_id", "");
    const reportManuallyUrl = config.covid_vacc_base_url + "v1/user-reported-vaccine-data/";
    const vaccineInfo = [
      {
        "name": vaccine,
        "date_of_vaccination": moment(date).format('YYYY-MM-DD'),
        "dose": doseNo
      }
    ]
    switch (source_id) {
      case "emp_xp": {
        if (!auth_token || !source_id || !source_user_id || !source_relation || (source_user_relation_id == undefined)) {
          setPageLoadError("Session expired, please login again");
          return false;
        }
        const userDetailsObj = {
          auth_token,
          source_id,
          source_user_id,
          source_relation,
          source_user_relation_id
        };

        const dataObj = vaccinationApiRequestBody({ "vaccine_info": vaccineInfo }, userDetailsObj);

        _setSubmitDetails(true);
        const response = await apiRequest(reportManuallyUrl, dataObj, true);
        _setSubmitDetails(false);

        if (lodash.get(response, "status") !== "success") {
          _setApiError(lodash.get(response, "response.data.message", "Something went wrong. Please try again."));
          return;
        }
        _setSubmitSuccess(true);
        _setDisableOptions(true);
        _onSubmitFinish();
        break;
      }
      case "jiohealthhub": {
        if (!auth_token || !source_user_id) {
          setPageLoadError("Session expired, please login again");
          return false;
        }
        const userDetailsObj = {
          auth_token,
          source_id,
          jhh_id: source_user_id,
        };

        const dataObj = vaccinationApiRequestBody({ "vaccine_info": vaccineInfo }, userDetailsObj);

        _setSubmitDetails(true);
        const response = await apiRequest(reportManuallyUrl, { dataObj }, true);
        _setSubmitDetails(false);

        if (lodash.get(response, "status") !== "success") {
          _setApiError(lodash.get(response, "response.data.message", "Something went wrong. Please try again."));
          return;
        }
        _setSubmitSuccess(true);
        _setDisableOptions(true);
        _onSubmitFinish();
        break;
      }
      default:
        break;
    }
  }

  return (
    <div className="update-vaccine-details">
      {((doseNo == 2 && hideQuestion === false) || showUpperHr) &&
        <div className="horizontal-line"></div>
      }
      {
        hideQuestion === false &&
        <div className="update-vaccine-details-head">
          <div className="update-vaccine-details-header">{question}</div>
          <div className="update-vaccine-details-buttons" ref={divRef1}>
            <button
              className={showManualForm ? `update-vaccine-details-yes-button button-selected no-cursor` : `update-vaccine-details-yes-button`}
              onClick={() => _handleYesClick()}
              disabled={showManualForm}
            >{t("YES")}</button>
            <button
              className={showManualForm ? `update-vaccine-details-no-button no-cursor` : `update-vaccine-details-no-button`}
              onClick={() => _handleNoClick()}
              disabled={showManualForm}
            >{t("NO")}</button>
          </div>
        </div>
      }
      {
        (showManualForm || hideQuestion) &&
        <div className="update-vaccine-details-form" ref={divRef2}>
          <div className="horizontal-line"></div>
          <div className="update-vaccine-details-guide-text"><i>{t("UPDATE_VACCINE_DETAILS_GUIDE_TEXT")}</i></div>
          <div className="update-vaccine-details-header-wrapper">
            <div className="update-vaccine-details-header">
              {t("PROVIDE_VACCINE_DETAILS_TEXT")}{doseNo}
            </div>
            <div className="update-vaccine-details-buttons">
              <button
                onClick={_handleUpload}
                className={
                  showUploadBox ? "update-vaccine-details-upload-button button-selected no-cursor"
                    : disableOptions ? "update-vaccine-details-upload-button no-cursor"
                      : "update-vaccine-details-upload-button"
                }
                disabled={showUploadBox || disableOptions}
              >
                {t("UPLOAD_CERTIFICATE")}
              </button>

                - or -

              <button
                onClick={_handleManual}
                className={
                  vccineDetailsInput ? "update-vaccine-details-manual-button button-selected no-cursor"
                    : disableOptions ? "update-vaccine-details-manual-button no-cursor"
                      : "update-vaccine-details-manual-button"
                }
                disabled={vccineDetailsInput || disableOptions}
              >
                {t("ENTER_VACCINE_INFO")}
              </button>
            </div>
          </div>
          {
            vccineDetailsInput &&
            <div className="update-vaccine-details-form-inputs">
              {/* <div className="horizontal-line"></div> */}
              <div className="update-vaccine-details-form-input-div">
                <div className="update-vaccine-details-form-title">{t("NAME_OF_VACCINE_DOSE")}{doseNo}:</div>
                <select
                  className="update-vaccine-details-form-input"
                  value={typeof vaccine !== undefined ? vaccine : ""}
                  onChange={_vaccineInput}
                  disabled={submitSuccess}
                >
                  {typeof vaccine_select_options !== "undefined" &&
                    vaccine_select_options.map((opt, index = 0) =>
                      opt.name === "" ? (
                        <option key={`${opt.name}${index++}select`} value="" disabled>
                          {opt.display_name}
                        </option>
                      ) : (
                        <option key={`${opt.name}${index++}select`} value={opt.name}>
                          {opt.display_name}
                        </option>
                      )
                    )}
                </select>
              </div>
              <div className="update-vaccine-details-form-input-div update-vaccine-details-submit-div">
                <div className="update-vaccine-details-form-title"></div>
                <div className={error.name ? "update-vaccine-details-error" : "hide-error"}>{error.name}</div>
              </div>
              <div className="update-vaccine-details-form-input-div">
                <div className="update-vaccine-details-form-title">{t("DATE_OF_VACCINE_DOSE")}{doseNo}:</div>
                <input
                  placeholder={"YYYY-MM-DD"}
                  onChange={_dateInput}
                  type="date"
                  value={date}
                  min={moment("2020-03-01").utcOffset("+05:30").format("YYYY-MM-DD")}
                  max={moment().utcOffset("+05:30").format("YYYY-MM-DD")}
                  className="update-vaccine-details-form-input"
                  disabled={submitSuccess}
                />
              </div>
              <div className="update-vaccine-details-form-input-div update-vaccine-details-submit-div">
                <div className="update-vaccine-details-form-title"></div>
                <div className={error.date ? "update-vaccine-details-error" : "hide-error"}>{error.date}</div>
              </div>
              <div className="update-vaccine-details-form-input-div update-vaccine-details-submit-div">
                <div className="update-vaccine-details-form-title"></div>
                <button
                  onClick={_onReportManuallySubmit}
                  disabled={submitDetails || submitSuccess}
                  className={submitDetails ? "update-vaccine-details-submit-button button-disable"
                    : submitSuccess ? "update-vaccine-details-submit-button no-cursor"
                      : "update-vaccine-details-submit-button"}
                >
                  {t("SUBMIT")}
                </button>
              </div>
              <div className="update-vaccine-details-form-input-div update-vaccine-details-submit-div">
                <div className="update-vaccine-details-form-title"></div>
                <div className={apiError ? "update-vaccine-details-error" : "hide-error"}>{apiError}</div>
              </div>
            </div>
          }
        </div>
      }
      {
        showUploadBox &&
        <div className="upload-component-wrapper">
          {(!disableOptions) && <UploadVaccineComponent classForStyling={"update-vaccine-details-upload-certificate"} _onSubmitFinish={() => { _onSubmitFinish(); _setDisableOptions(true) }} noMargin={true} />}
          {(disableOptions) && <GetLastVaccinationDetails classForStylingLoader={"update-vaccine-details-loader"} guideTextAfterUpload={"Latest details might take some time to reflect"} classForStylingButton={"update-vaccine-details-upload-certificate"} classForStylingPrevVacc={"update-vaccine-details-upload-certificate update-vaccine-details-prev-vacc"} hideImage={true} />}
        </div>
      }
      {/* { (showUploadBox && (disableOptions) && !vccineDetailsInput) &&
        <div>{t("CERTIFICATE_UPLOAD_SUCCESS")}</div>
      } */}
    </div>
  );
};

export default UpdateVaccineDetails;